<router-outlet></router-outlet>
@if (isTest) {
    <div class="test-flag">test</div>
}
